import { api } from './api';
import { Cart, ValidationError } from './cart.models';

export const submitCart = async (cart: Cart) => {
	let response = await api.post<ValidationError[]>(`/api/cart`, cart);
	return response.data;
}